import axiosClient from "../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/pre-check/${id}`)
    return result.data
}
